import { render, staticRenderFns } from "./agreeForm.vue?vue&type=template&id=a4fa8618&scoped=true"
import script from "./agreeForm.vue?vue&type=script&lang=js"
export * from "./agreeForm.vue?vue&type=script&lang=js"
import style0 from "./agreeForm.vue?vue&type=style&index=0&id=a4fa8618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fa8618",
  null
  
)

export default component.exports